import moment from 'moment/moment';
import RcPagination from 'rc-pagination';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Button, Card, CardBody, CardHeader, Input, Table } from 'reactstrap';
import {
  getColorModelOption,
  getRepairBrandOption,
  getRepairModelOption,
  getRepairOptions,
} from 'redux/actions/data/repairActions';
import CommonUtil from 'utils/CommonUtil';
import * as Yup from 'yup';

import Layout from '../components/Layout';
import TableHasNoData, { TableLoading } from '../components/TableHasNoData';
import WarrantyDateSettingModal from '../components/warrantyRegisterDetails/WarrantyDateSettingModal';
import {
  BatchReview,
  exportWarrantyRegister,
  getWarrantyRegisterDetails,
  getWarrantyRegisterList,
  reviewWarrantyRegister,
} from '../redux/actions/data/warrantyActions';
import {
  WARRANTY_REGISTER_DETAILS_RESET,
  WARRANTY_REGISTER_EXPORT_RESET,
  WARRANTY_REGISTER_REVIEW_RESET,
} from '../redux/constants/data/warrantyConstants';
import style from '../styles/layout.module.css';
import MessageUtil from '../utils/MessageUtil';
import history from '../utils/createHistory';
import { modal as modalUtils } from '../utils/modal';
import useQuery from '../utils/useQuery';

import { isNewOption } from './WarrantyRegister';

const WarrantyRegisterVerifying = () => {
  const dispatch = useDispatch();
  const { location } = history;
  const query = useQuery();

  // const page_size = 10;

  const [current_page, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [brand, setBrand] = useState({ label: '請選擇品牌', value: 0 });
  const [model, setModel] = useState({ label: '請選擇型號', value: '' });
  const [color, setColor] = useState({ label: '請選擇顏色', value: '' });
  const [isNew, setIsNew] = useState({ label: '全部', value: null });
  const [status, setStatus] = useState('審核中');

  const { repairBrandOptions, loading: repairBrandOptionsLoading } =
    useSelector(state => state.repairBrandOptions);
  const { repairModelOptions, loading: repairModelOptionsLoading } =
    useSelector(state => state.repairModelOptions);
  const { repairColorOptions, loading: repairColorOptionsLoading } =
    useSelector(state => state.repairColorOptions);

  const { loading, warrantyRegisterListInfo, error } = useSelector(
    state => state.warrantyRegisterList,
  );
  const { result } = useSelector(state => state.warrantyRegisterExport);

  const { maintainOptions, loading: maintainOptionsLoading } = useSelector(
    state => state.maintainOptions,
  );

  const [supplier, setSupplier] = useState([
    {
      label: '請選擇經銷商',
      value: '',
    },
  ]);

  const handleSubmit = values => {
    if (infoRef.current) {
      const object = {
        ...values,
        productDate_admin: values.shippingDate
          ? moment(values.shippingDate).format('YYYY/MM/DD HH:mm')
          : infoRef.current.productDate_admin
          ? moment(infoRef.current.productDate_admin).format('YYYY/MM/DD HH:mm')
          : '',
        purchaseDate_admin: values.purchaseDate
          ? moment(values.purchaseDate).format('YYYY/MM/DD HH:mm')
          : infoRef.current.purchaseDate_admin
          ? moment(infoRef.current.purchaseDate_admin).format(
              'YYYY/MM/DD HH:mm',
            )
          : '',
        reason: values.reason,
        startDateType_admin: Number(values.startDateType_admin),
        status: values.status,
        warrantyEndDate: values.warrantyEndDate
          ? moment(values.warrantyEndDate).format('YYYY/MM/DD HH:mm')
          : infoRef.current.warrantyEndDate
          ? moment(infoRef.current.warrantyEndDate).format('YYYY/MM/DD HH:mm')
          : '',
        warrantyRegisterId: infoRef.current.id,
      };
      dispatch(reviewWarrantyRegister(object));
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryPage = query.value.page;
      const queryKeyword = query.value.keyword
        ? JSON.parse(query.value.keyword)
        : '';
      const queryBrand = query.value.brand;
      const queryModel = query.value.model ? JSON.parse(query.value.model) : '';
      const queryColor = query.value.color ? JSON.parse(query.value.color) : '';
      const queryStatus = query.value.status;
      let queryChannel = '';
      try {
        queryChannel = JSON.parse(query.value.purchaseChannelIds);
      } catch (e) {}

      let querySupplier = '';
      try {
        querySupplier = JSON.parse(query.value.supplier);
      } catch (e) {}

      let queryIsNew = null;
      try {
        queryIsNew = JSON.parse(query.value.isNew);
        setIsNew(isNewOption.find(o => o.value === queryIsNew));
      } catch (e) {
        setIsNew(isNewOption.find(o => o.value === null));
      }

      const queryPageSize = query.value.page_size || 50;
      setCurrentPage(queryPage);
      setPageSize(queryPageSize);

      if (
        queryKeyword ||
        queryBrand ||
        queryModel ||
        queryColor ||
        queryStatus ||
        queryChannel ||
        queryPageSize ||
        querySupplier
      ) {
        setKeyword(queryKeyword);
        setBrand(
          repairBrandOptions &&
            repairBrandOptions.find(option => option.value == queryBrand)
            ? repairBrandOptions.find(option => option.value == queryBrand)
            : brand,
        );
        setModel(
          repairModelOptions &&
            repairModelOptions.find(option => option.value == queryModel)
            ? repairModelOptions.find(option => option.value == queryModel)
            : model,
        );
        setColor(
          repairColorOptions &&
            repairColorOptions.find(option => option.value == queryColor)
            ? repairColorOptions.find(option => option.value == queryColor)
            : color,
        );

        setChannel(
          maintainOptions?.allChannels &&
            maintainOptions.allChannels.filter(option =>
              String(queryChannel).split('-').includes(String(option.value)),
            ) &&
            queryIsNew !== null &&
            !queryIsNew
            ? maintainOptions.allChannels.filter(option =>
                String(queryChannel).split('-').includes(String(option.value)),
              )
            : [{ label: '請選擇通路', value: 0 }],
        );

        setSupplier(
          queryIsNew !== null && queryIsNew && maintainOptions?.suppliers
            ? maintainOptions.suppliers.filter(option =>
                String(querySupplier).split('-').includes(String(option.value)),
              )
            : [{ label: '請選擇經銷商', value: '' }],
        );

        dispatch(
          getWarrantyRegisterList({
            brandId: queryBrand,
            color: queryColor,
            isNew: queryIsNew,
            keyword: String(queryKeyword),
            model: queryModel,
            page: queryPage,
            page_size: queryPageSize,
            purchaseChannelIds: String(queryChannel)
              .split('-')
              .map(s => Number(s))
              .filter(s => s),
            status: queryStatus,
            supplierCodes: String(querySupplier)
              .split('-')
              .filter(s => s),
          }),
        );
      } else {
        //單純記錄頁數
        dispatch(
          getWarrantyRegisterList({
            page: queryPage,
            page_size: queryPageSize,
            status,
          }),
        );
      }
    } else {
      //初始化狀態、避免下次跳轉遺留
      setCurrentPage(1);
      setKeyword('');
      setBrand({ label: '請選擇品牌', value: 0 });
      setModel({ label: '請選擇型號', value: '' });
      setColor({ label: '請選擇顏色', value: '' });
      setIsNew({ label: '全部', value: null });

      // setStatus('');
      setChannel([{ label: '請選擇通路', value: 0 }]);
      setPageSize(50);
      setSupplier([{ label: '請選擇經銷商', value: '' }]);

      //初始搜尋
      dispatch(
        getWarrantyRegisterList({
          page: 1,
          page_size: pageSize,
          status,
        }),
      );
    }
  }, [location.search]);

  useEffect(() => {
    dispatch(getRepairBrandOption(0, 0));
    dispatch(getRepairOptions());
  }, []);

  useEffect(() => {
    brand.value && dispatch(getRepairModelOption(0, 0, brand.value));
  }, [brand]);

  useEffect(() => {
    model.value && dispatch(getColorModelOption(0, 0, model.value));
  }, [model]);

  useEffect(() => {
    if (result) {
      window.open(result);
    }
    return () => {
      dispatch({ type: WARRANTY_REGISTER_EXPORT_RESET });
    };
  }, [result]);

  useEffect(() => {
    if (warrantyRegisterListInfo) {
      if (JSON.stringify(warrantyRegisterListInfo) !== '{}') {
        CommonUtil.consoleLog({
          anno: 'response',
          data: warrantyRegisterListInfo,
        });
      }
    }
  }, [warrantyRegisterListInfo]);

  const handleSearch = e => {
    e?.preventDefault();
    setCurrentPage(1);
    history.push(
      `${location.pathname}?keyword=${JSON.stringify(keyword)}&brand=${
        brand.value
      }&model=${JSON.stringify(model.value)}&color=${JSON.stringify(
        color.value,
      )}&status=${status}&page=${1}&purchaseChannelIds=${JSON.stringify(
        channel?.map(s => s.value).join('-'),
      )}&page_size=${pageSize}&supplier=${JSON.stringify(
        supplier?.map(s => s.value).join('-'),
      )}&isNew=${isNew.value}&v=${new Date().getTime()}`,
    );
  };

  const handleChangePageSize = page_size => {
    setCurrentPage(1);
    history.push(
      `${location.pathname}?keyword=${JSON.stringify(keyword)}&brand=${
        brand.value
      }&model=${JSON.stringify(model.value)}&color=${JSON.stringify(
        color.value,
      )}&status=${status}&page=${1}&purchaseChannelIds=${JSON.stringify(
        channel?.map(s => s.value).join('-'),
      )}&page_size=${page_size}&supplier=${JSON.stringify(
        supplier?.map(s => s.value).join('-'),
      )}&isNew=${isNew.value}`,
    );
  };

  const clearSearchForm = () => {
    setCurrentPage(1);
    setKeyword('');
    setBrand({ label: '請選擇品牌', value: 0 });
    setModel({ label: '請選擇型號', value: '' });
    setColor({ label: '請選擇顏色', value: '' });
    setIsNew({ label: '全部', value: null });
    setChannel([{ label: '請選擇通路', value: 0 }]);
    setPageSize(50);
    setSupplier([{ label: '請選擇經銷商', value: '' }]);
    history.push(`${location.pathname}`);
  };

  const handleExport = () => {
    const exportObject = {
      brandId: brand.value,
      color: color.value,
      isNew: isNew.value,
      keyword,
      model: model.value,
      page: current_page,
      page_size: pageSize,
      purchaseChannelIds: channel?.map(s => Number(s.value)).filter(s => s),
      status,
      supplierCodes: supplier?.map(s => s.value).filter(s => s),
    };
    dispatch(exportWarrantyRegister(exportObject));
  };

  const handlePageChange = page => {
    setCurrentPage(page);
    history.push(
        `${location.pathname}?keyword=${keyword}&brand=${
            brand.value
        }&model=${JSON.stringify(model.value)}&color=${JSON.stringify(
            color.value,
        )}&status=${status}&page=${page}&purchaseChannelIds=${JSON.stringify(
            channel?.map(s => s.value).join('-'),
        )}&page_size=${pageSize}&supplier=${JSON.stringify(
            supplier?.map(s => s.value).join('-'),
        )}&isNew=${isNew.value}`,
    );
  };

  const [channel, setChannel] = useState([{ label: '請選擇通路', value: 0 }]);
  const [pageSize, setPageSize] = useState(50);

  const [otherReason, setOtherReason] = useState('');
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const [selectData, setSelectData] = useState([]);
  const infoRef = useRef('');

  const { loading: addLoading } = useSelector(state => state.warrantyAddRemark);
  const {
    loading: submitLoading,
    success: submitSuccess,
    error: submitError,
  } = useSelector(state => state.warrantyRegisterReview);

  useEffect(() => {
    if (infoRef.current && modal && !submitLoading) {
      if (submitSuccess) {
        MessageUtil.alertSuccess('更新成功');
        isClickRef.current = false;
        setModal(false);
        handleSearch();
        infoRef.current = null;
      }
      if (submitError) {
        MessageUtil.alertWanring(submitError);
      }
    }
  }, [submitLoading, submitSuccess, submitError]);
  const { loading: detailLoading, warrantyRegisterDetailsInfo } = useSelector(
    state => state.warrantyRegisterDetails,
  );
  const isClickRef = useRef(false);
  useEffect(() => {
    if (
      !modal &&
      isClickRef.current &&
      !infoRef.current &&
      warrantyRegisterDetailsInfo &&
      !detailLoading
    ) {
      infoRef.current = warrantyRegisterDetailsInfo;
      setModal(true);
      dispatch({ type: WARRANTY_REGISTER_DETAILS_RESET });
      dispatch({ type: WARRANTY_REGISTER_REVIEW_RESET });
    }
    return () => {
      dispatch({ type: WARRANTY_REGISTER_DETAILS_RESET });
      dispatch({ type: WARRANTY_REGISTER_REVIEW_RESET });
    };
  }, [warrantyRegisterDetailsInfo]);

  const getValidationSchema = () => {
    const schema = Yup.object().shape(
      {
        purchaseDate: Yup.date().when('startDateType_admin', {
          is: startDateType_admin => startDateType_admin == 1,
          then: Yup.date().required('請填入購買日期').nullable(),
        }),
        reason: Yup.string().when('status', {
          is: status => status == '未通過',
          then: Yup.string().required('請填入原因'),
        }),
        shippingDate: Yup.date().when('startDateType_admin', {
          is: startDateType_admin => startDateType_admin == 2,
          then: Yup.date().required('請填入出貨日期').nullable(),
        }),
        startDateType_admin: infoRef?.current?.warrantyDays
          ? Yup.string().required('必填')
          : Yup.string(),
        status: Yup.string().required('必填'),
        warrantyEndDate: infoRef?.current?.warrantyDays
          ? Yup.date().required('必填').nullable()
          : Yup.date().nullable(),
      },
      ['startDateType_admin', 'purchaseDate', 'shippingDate'],
    );
    return schema;
  };

  return (
    <Layout
      pageTitle="審核中清單"
      items={[
        { isActive: false, page_name: '產品保固註冊' },
        { isActive: true, page_name: '審核中' },
      ]}
    >
      <Card className={style.search_card}>
        <CardHeader className="bg-white">搜尋條件</CardHeader>
        <CardBody className={style.card_body}>
          <form onSubmit={handleSearch}>
            <div className={style.show_flex}>
              <div
                className={style.formGroup}
                style={{ marginRight: '1.5rem' }}
              >
                <label className="col-form-label mr-2" htmlFor="keyword">
                  關鍵字
                </label>
                <input
                  id="keyword"
                  type="text"
                  className={`form-control ${style['form-input']}`}
                  placeholder="電話、購買通路"
                  onChange={e => setKeyword(e.target.value.trim())}
                  value={keyword}
                />
              </div>
              <div
                className={style.formGroup}
                style={{ marginRight: '1.5rem' }}
              >
                <label className="col-form-label mr-2" htmlFor="brandName">
                  品牌
                </label>
                <Select
                  isLoading={repairBrandOptionsLoading}
                  isDisabled={repairBrandOptionsLoading}
                  name="brandName"
                  className={style['form-select']}
                  options={
                    repairBrandOptions
                      ? [{ label: '全部', value: 0 }, ...repairBrandOptions]
                      : []
                  }
                  onChange={option => {
                    setBrand(option);
                    setModel({ label: '請選擇品牌', value: '' });
                    setColor({ label: '請選擇顏色', value: '' });
                  }}
                  value={brand}
                  style={{ margin: 0 }}
                />
              </div>
              <div
                className={style.formGroup}
                style={{ marginRight: '1.5rem' }}
              >
                <label className="col-form-label mr-2" htmlFor="model">
                  型號
                </label>
                <Select
                  isLoading={repairModelOptionsLoading}
                  isDisabled={repairModelOptionsLoading}
                  name="model"
                  className={style['form-select']}
                  options={
                    repairModelOptions
                      ? [{ label: '全部', value: '' }, ...repairModelOptions]
                      : []
                  }
                  onChange={option => {
                    setModel(option);
                    setColor({ label: '請選擇顏色', value: '' });
                  }}
                  value={model}
                  style={{ margin: 0 }}
                />
              </div>
              <div
                className={style.formGroup}
                style={{ marginRight: '1.5rem' }}
              >
                <label className="col-form-label mr-2" htmlFor="color">
                  顏色
                </label>
                <Select
                  isLoading={repairColorOptionsLoading}
                  isDisabled={repairColorOptionsLoading}
                  name="color"
                  className={style['form-select']}
                  options={
                    repairColorOptions
                      ? [{ label: '全部', value: '' }, ...repairColorOptions]
                      : []
                  }
                  onChange={option => setColor(option)}
                  value={color}
                  style={{ margin: 0 }}
                />
              </div>
              <div
                className={style.formGroup}
                style={{ marginRight: '1.5rem' }}
              >
                <label style={{ marginRight: '1.5rem' }}>新舊保卡</label>
                <Select
                  options={isNewOption}
                  value={isNew}
                  onChange={option => {
                    setSupplier([{ label: '請選擇經銷商', value: '' }]);
                    setChannel([{ label: '請選擇通路', value: 0 }]);
                    setIsNew(option);
                  }}
                />
              </div>
              {isNew.value !== null && !isNew.value && (
                <div
                  className={style.formGroup}
                  style={{ marginRight: '1.5rem' }}
                >
                  <label style={{ marginRight: '1.5rem' }}>購買通路</label>
                  <Select
                    isLoading={maintainOptionsLoading}
                    isDisabled={maintainOptionsLoading}
                    options={maintainOptions?.allChannels}
                    isMulti
                    value={channel}
                    onChange={option => {
                      setChannel(option);
                    }}
                  />
                </div>
              )}
              {isNew.value !== null && isNew.value && (
                <div
                  className={style.formGroup}
                  style={{ marginRight: '1.5rem' }}
                >
                  <label style={{ marginRight: '1.5rem' }}>經銷商</label>
                  <Select
                    isLoading={maintainOptionsLoading}
                    isDisabled={maintainOptionsLoading}
                    className={style['form-select']}
                    options={maintainOptions?.suppliers}
                    isMulti
                    value={supplier}
                    onChange={option => {
                      setSupplier(option);
                    }}
                  />
                </div>
              )}
            </div>

            <div className={style.button_position}>
              <Button
                type="button"
                className={style.modal_button_cancel}
                onClick={clearSearchForm}
              >
                取消
              </Button>
              <Button type="submit" className={style.modal_button_submit}>
                查詢
              </Button>
            </div>
          </form>
        </CardBody>
      </Card>
      <Card className={style.card}>
        <div className="d-flex justify-content-between">
          <div className="d-inline-flex gap-2 align-items-start">
            <Button
              className="btn btn-success w100 h-auto"
              onClick={handleExport}
            >
              匯出Excel
            </Button>
            <Button
              className="btn btn-success h-auto"
              disabled={!selectData.length}
              onClick={() => {
                MessageUtil.confirm(
                  '批次通過的申請單會統一採用 [購買日期] 作為保固起始日',
                  '',
                  () => {
                    BatchReview(
                      selectData.map(d => {
                        return {
                          productSerialNum: d.productSerialNum,
                          warrantyRegisterId: d.id,
                          warrantySerialNum: d.warrantySerialNum,
                        };
                      }),
                    )
                      .then(res => {
                        MessageUtil.alertSuccess('更新成功');
                        setSelectData([]);
                        handleSearch();
                      })
                      .catch(e => {
                        MessageUtil.alertWanring(e);
                      });
                  },
                );
              }}
            >
              批次通過
            </Button>
          </div>
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-end align-items-center">
              每頁
              <Input
                type="select"
                name="page_size"
                style={{ margin: '0.3rem', width: '80px' }}
                onChange={event => {
                  setPageSize(event.target.value);
                  handleChangePageSize(event.target.value);
                }}
                value={pageSize}
              >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="150">150</option>
              </Input>
              筆
            </div>
            <div className="d-flex justify-content-end">
              共
              <span className="mx-1">
                {!loading &&
                warrantyRegisterListInfo &&
                warrantyRegisterListInfo.total_count > 0
                  ? warrantyRegisterListInfo.total_count
                  : '0'}
              </span>
              筆
            </div>
          </div>
        </div>

        <div className="table-responsive mb-5">
          <Table hover bordered striped>
            <thead className={`thead-dark ${style.table_head}`}>
              <tr>
                <th align="center">
                  <input
                    className={style.maintain_list_checkbox}
                    type="checkbox"
                    name="all"
                    onChange={e => {
                      if (
                        warrantyRegisterListInfo?.datas?.every(data => {
                          return (
                            selectData.map(d => d.id).indexOf(data.id) > -1
                          );
                        })
                      ) {
                        setSelectData(
                          selectData.filter(data => {
                            return (
                              warrantyRegisterListInfo?.datas
                                ?.map(d => d.id)
                                .indexOf(data.id) === -1
                            );
                          }),
                        );
                      } else {
                        setSelectData([
                          ...selectData.filter(data => {
                            return (
                              warrantyRegisterListInfo?.datas
                                ?.map(d => d.id)
                                .indexOf(data.id) === -1
                            );
                          }),
                          ...(warrantyRegisterListInfo?.datas || []),
                        ]);
                      }
                    }}
                    checked={
                      !loading &&
                      warrantyRegisterListInfo?.datas?.every(data => {
                        return selectData.map(d => d.id).indexOf(data.id) > -1;
                      })
                    }
                  />
                  全選
                </th>
                <th>功能</th>
                <th>電話</th>
                <th>品牌</th>
                <th>型號/顏色/尺寸</th>
                <th>購買通路</th>
                <th>經銷商</th>
                <th>保卡序號</th>
                <th>產品序號</th>
                <th>購買日期</th>
                <th>保固日期</th>
                <th>審核狀態</th>
                <th>發票/保卡圖片</th>
              </tr>
            </thead>
            {loading && <TableLoading />}
            {!loading && (
              <tbody>
                {warrantyRegisterListInfo ? (
                  warrantyRegisterListInfo.datas.map(data => (
                    <tr key={JSON.stringify(data)}>
                      <td align="center">
                        <input
                          className={style.maintain_list_checkbox}
                          type="checkbox"
                          onChange={() => {
                            if (
                              selectData.map(d => d.id).indexOf(data.id) > -1
                            ) {
                              setSelectData(
                                selectData.filter(d => {
                                  return d.id !== data.id;
                                }),
                              );
                            } else {
                              setSelectData([...selectData, data]);
                            }
                          }}
                          checked={
                            selectData.map(d => d.id).indexOf(data.id) > -1
                          }
                        />
                      </td>
                      <td className="text-nowrap">
                        <Button
                          outline
                          color="primary"
                          size="sm"
                          onClick={() => {
                            infoRef.current = null;
                            isClickRef.current = true;
                            dispatch(getWarrantyRegisterDetails(data.id));
                          }}
                        >
                          編輯
                        </Button>
                        <Link
                          className="m-2 btn btn-outline-primary btn-sm"
                          to={`/WarrantyRegisterDetails/${data.id}`}
                        >
                          詳細資料
                        </Link>
                      </td>
                      <td className="text-nowrap">
                        {data.countryCode === '886' ? '0' : data.countryCode}
                        {data.phone}
                      </td>
                      <td className="text-nowrap">{data.brandName}</td>
                      <td className="text-nowrap">
                        {data.model}/{data.color}/{data.size}
                      </td>
                      <td nowrap="nowrap">
                        {/*購買通路*/}
                        {data.purchaseChannelName || '--'}
                      </td>
                      <td nowrap="nowrap">
                        {/*經銷商*/}
                        {data.supplierChanneName || '--'}
                      </td>
                      <td className="text-nowrap">
                        {data?.warrantySerialNum || '--'}
                      </td>
                      <td>{data?.productSerialNum || '--'}</td>
                      <td className="text-nowrap">
                        {data.purchaseDate || '--'}
                      </td>
                      <td className="text-nowrap">
                        {data.warrantyDays ? (
                          <>
                            <p>起：{data.warrantyStartDate || '--'}</p>
                            <p>訖：{data.warrantyEndDate || '--'}</p>
                          </>
                        ) : (
                          '無'
                        )}
                      </td>
                      <td>{data.status}</td>
                      <td>
                        {data?.warrantyimgList?.map(img => {
                          return (
                            <img
                              role="button"
                              src={img.imageUrl}
                              alt={img.imageUrl}
                              width="50"
                              key={`${JSON.stringify(data)}_${JSON.stringify(
                                img,
                              )}`}
                              onClick={() => {
                                modalUtils.showFillImage(img.imageUrl);
                              }}
                            />
                          );
                        })}
                      </td>
                    </tr>
                  ))
                ) : (
                  <TableHasNoData />
                )}
              </tbody>
            )}
          </Table>
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <RcPagination
            defaultCurrent={warrantyRegisterListInfo?.current_page || 1}
            defaultPageSize={pageSize}
            total={warrantyRegisterListInfo?.total_count || 0}
            onChange={handlePageChange}
          />
        </div>
        {modal && (
          <WarrantyDateSettingModal
            toggleModal={toggleModal}
            handleSubmit={handleSubmit}
            getValidationSchema={getValidationSchema}
            modal={modal}
            info={infoRef.current}
            otherReason={otherReason}
            setOtherReason={setOtherReason}
            addLoading={addLoading}
            submitLoading={submitLoading}
          />
        )}
      </Card>
    </Layout>
  );
};

export default WarrantyRegisterVerifying;
